export default "__VITE_ASSET__4f5577df__"